import request from '@/utils/request'

// 核实收款
export const checkTenderFee = (data) => {
  return request.post('/api/agent/audit/tenderFee/check?orderNumber=' + data.orderNumber + '&status=' + data.status + '&reason=' + data.reason, data)
}
// 标段标书款列表
export const getTenderFeeList = (data) => {
  return request.get('/api/agent/audit/tenderFee/feeList', data)
}